import styled from 'styled-components'

export const TagContainer = styled.div<{ color: string }>`
  position: relative;
  width: fit-content;
  padding: 0 5px 0 19px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ color }) => color};
  border-radius: 5px 0px 0px 5px;

  * {
    pointer-events: none;
  }

  &:before {
    content: '';
    position: absolute;
    left: 5px;
    top: 50%;
    width: 6px;
    height: 6px;

    border-radius: 50%;
    background: ${props => props.theme.colors.colorf3f5f9};
    transform: translateY(-50%);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
    right: -13px;
    border-top: 13px solid transparent;
    border-bottom: 13px solid transparent;
    border-left: 13px solid ${({ color }) => color};
  }
`

export const TagText = styled.span`
  font-size: 12px;
  line-height: 26px;
  font-family: Inter;
  color: ${({ theme }) => theme.zds.colors.neutral1000};
`
